import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"
import {
  fetchOrganizationsSuccess,
  clearOrganizationState,
} from "../../Organization/actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
// import {
//   postFakeLogin,
//   postJwtLogin,
// } from "../../../helpers/fakebackend_helper"

import axios from "axios"
import config from "../../../config/config"

const fireBaseBackend = getFirebaseBackend()

const postLoginApi = async user => {
  const response = await axios.post(`${config.backendUrl}/auth/login`, {
    email: user.email,
    password: user.password,
  })
  return response.data
}
const fetchLoginUser = async user => {
  const response = await axios.get(
    `${config.backendUrl}/user/getLoginUser?userId=${user.id}`,
  )
  return response.data
}
function* loginUser({ payload: { user, history } }) {
  try {
    const loginResponse = yield call(postLoginApi, user)
    console.log("Response :", loginResponse)

    yield put(loginSuccess(loginResponse.userInfo))
    console.log("sdjbvs", user)
    const userResponse = yield call(fetchLoginUser, loginResponse.userInfo)
    yield put(
      fetchOrganizationsSuccess(userResponse.userInfo.assignedOrganizations),
    )

    history("/dashboard")
  } catch (error) {
    // Dispatch API error if the login fails
    console.log(error)
    yield put(
      apiError(error.response ? error.response.data.message : "Login failed"),
    )
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    yield put(logoutUserSuccess())
    yield put(clearOrganizationState())
    history("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(fireBaseBackend.socialLoginUser, type)
      if (response) {
        history("/dashboard")
      } else {
        history("/login")
      }
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    const response = yield call(fireBaseBackend.socialLoginUser, type)
    if (response) history("/dashboard")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
